// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileLayout_wrapper__NX+Sg","content":"MobileLayout_content__dUXIx","contact":"MobileLayout_contact__cxnL6"};